/**
 * Graphology Utils
 * =================
 *
 * Library endpoint.
 */
exports.inferMulti = require('./infer-multi.js');
exports.inferType = require('./infer-type.js');
exports.isGraph = require('./is-graph.js');
exports.isGraphConstructor = require('./is-graph-constructor.js');
exports.mergeClique = require('./merge-clique.js');
exports.mergeCycle = require('./merge-cycle.js');
exports.mergePath = require('./merge-path.js');
exports.mergeStar = require('./merge-star.js');
exports.renameGraphKeys = require('./rename-graph-keys.js');
exports.updateGraphKeys = require('./update-graph-keys.js');
